import {createNamespacedHelpers} from "vuex";
import {GET_SYSTEM_CACHE} from "@/store/modules/force-news/type";
import IConstants from "@/common/constants/IConstants";
const {mapActions: mapForceNewsAction} = createNamespacedHelpers('forceNews');
const {mapGetters: mapForceNewGetters} = createNamespacedHelpers('forceNews');

const postDocTemplateMixin = {
    created() {
        this[GET_SYSTEM_CACHE]();
    },
    computed: {
        ...mapForceNewGetters(['mapReportTemplateCache']),
        postDocTemplate() {
            if (this.mapReportTemplateCache) {
                return this.mapReportTemplateCache[IConstants.SYSTEM_CONFIG_KEY.REPORT_TEMPLATE + IConstants.JASPER_TEMPLATE.CD_POST_DOC];
            }
        },
        telephone() {
            if (this.postDocTemplate) {
                return this.postDocTemplate[IConstants.JASPER_TEMPLATE.POST_DOC_TELEPHONE];
            }
        },
    },
    methods: {
        ...mapForceNewsAction([GET_SYSTEM_CACHE])
    }
};
export default postDocTemplateMixin;
